import { Link, useLocation } from "react-router-dom";
import { userHasElevatedAccess } from "../utils/Benefits";
import { useState } from "react";
import useUserStore from "../stores/User";


const Footer = () => {
  const location = useLocation();
  const userData = useUserStore((state) => state.data);
  const [dismissed, setDismissed] = useState(false);
  const suppressFooter = ['/indexerdashboard', '/curatorspage', '/admin', '/databaselogin', '/register', '/resetpassword', '/newpassword'];
  const isVip = userHasElevatedAccess(userData);
  if (suppressFooter.includes(location.pathname.toLowerCase())) {
    return null;
  }
  if (isVip && dismissed) return null;
  return (
    <footer className="mt-auto p-2 fixed-bottom d-none d-md-block">
      {isVip ? (
        <p className="text-center m-0 fs-6">
          VIP Patron Connected. Thank you for supporting Script Hive!
          <button
            type="button"
            className="btn btn-link p-0 ms-2 align-baseline border-0 lh-1"
            aria-label="Dismiss"
            onClick={() => setDismissed(true)}
          >
            <i className="bi bi-x-lg" />
          </button>
        </p>
      ) : (
        <p className="text-center m-0 fs-6">
          Enjoying Script Hive? Connect your Patreon to unlock Script Requests and up to 100 daily downloads!{" "}
          <Link
            to="https://patreon.com/scripthive"
            className="btn btn-primary navbutton"
            target="_blank"
            title="Support Script Hive on Patreon"
            rel="noopener noreferrer"
          >
            Connect
          </Link>
        </p>
      )}
    </footer>
  );
};

export default Footer;
